import React, { FC } from "react";

import { styled } from "@mui/system";

import CircularProgress from "@mui/material/CircularProgress";

const ProgressContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  height: "100vh",
  justifyContent: "center",
  alignItems: "center",
}));

const PageProgress: FC = () => {
  return (
    <ProgressContainer>
      <CircularProgress color="primary" />
    </ProgressContainer>
  );
};

export default PageProgress;
